//dependencias
import React, { Component } from 'react';

//componentes
import ExpedienteMDN from './expedienteMateriasDN'

class Index extends Component {

    render(){
        return(
            <div>
                <ExpedienteMDN />
            </div>
        );
    }

}
export default Index;